import {
    DashboardBarChartDataElementType,
    DashboardBarChartDataMapType,
    DashboardDoughnutChartDataElementType,
    DashboardDoughnutChartDataMapType,
    DashboardOrderStatusType,
    DashboardSettingListElementType,
    DashboardSettingListMapType,
    DashboardSettingSearchParamType
} from "../interface";

export const dashboardSettingSearchParamInit: DashboardSettingSearchParamType = {
    deleteFlagList: ["Y", "N"],
    keyword: "",
    keywordType: "0",
    limit: 10,
    pageNo: 1,
    paginationFlag: "Y"
}

export const dashboardOrderStatusInit: DashboardOrderStatusType = {
    shipmentCount: 0,
    orderCount: 0,
    shipmentRequestCount: 0,
    transferCount: 0,
    completeCount: 0,
    totalCount: 0,
    rmaCount: 0
}

export const dashboardSettingListMapInit: DashboardSettingListMapType = {
    totalCount: 0,
    dashboardInfoVOList: []
}

export const dashboardSettingListElementInit: DashboardSettingListElementType = {
    dashboardInfoId: 0,
    userId: 0,
    infoIndex: 0,
    dashboardOrder: 0,
    reportName: "",
    dashboardType: "",
    isHidden: "",
    deleteFlag: "",
}

export const dashboardDoughnutChartDataMapInit: DashboardDoughnutChartDataMapType = {
    revenueCircleGraphResList: [],
    transferRevenueCircleGraphResList: []
}

export const dashboardDoughnutChartDataElementInit: DashboardDoughnutChartDataElementType = {
    newName: "",
    percentage: 0
}

export const dashboardBarChartDataMapInit: DashboardBarChartDataMapType = {
    dashboardSingleVOList: [],
}

export const dashboardBarChartDataElementInit: DashboardBarChartDataElementType = {
    revenueGoal: 0,
    revenueValue: 0,
    transferRevenueValue: 0,
    dataName: ""
}